import Vue from 'vue';

var resource = Vue.axiosFactory.create({baseURL: 'app/google/'});

export default {
  listYoutubeVideos(keyword) {
    return resource({method: 'get', url: 'list_youtube_videos', params: {keyword}});
  },
  getPlaceByZipcode({zipcode, country} = {}) {
    return resource({method: 'get', url: 'get_place_by_zipcode', params: {zipcode, country}});
  },
  placeAutoComplete({text, country} = {}) {
    return Promise.resolve(text ? (resource({
      method: 'get',
      url: 'place_autocomplete',
      params: {text, country}
    })).then(res => res.places).catch(console.log) : []);
  },
  findPlace(text) {
    return resource({method: 'get', url: 'find_place', params: {text}});
  },
  listNearbyCities({country, zipcode, radius, population}) {
    return resource({
      method: 'get',
      url: 'list_nearby_cities',
      params: {country, zipcode, radius, population, filterBlacklisted: true}
    });
  },
  listNearbyZipcodes(params) {
    return resource({method: 'get', url: 'list_nearby_zipcodes', params});
  },
  indexDomains(domains, credentials)  {
    return resource({method: 'post', url: 'index_domains', data: {domains, credentials}})
  },
  generateGSCReport(domain, startDate, endDate, maxNumberOfResults, domainsFilter, domainFilter2, getCount, textToInclude, textToExclude) {
    return resource({method: 'post', url: 'gsc_generate_report', data: {domain, startDate, endDate, maxNumberOfResults, domainsFilter, domainFilter2, getCount, textToInclude, textToExclude}});
  },
  generateKeywordsReport(domain, keywords) {
    return resource({method: 'post', url: 'keywords_report', data: {domain, keywords}});
  },
  gptTest(prompt) {
    return resource({method: 'post', url: 'gpt_test', data: {prompt}});
  },
};
